// import { CommentIcon } from '@components/Icons/CommentIcon.';
// import { FavoriteIcon } from '@components/Icons/FavoriteIcon';
// import { OptionsIcon } from '@components/Icons/OptionsIcon';
import { PlayIcon } from '@components/Icons/PlayIcon';
import { RightArrowIcon2 } from '@components/Icons/RightArrowIcon2';
// import { SavedIcon } from '@components/Icons/SavedIcon';
import { useMusicState } from '@hooks/storeHooks/useMusicState';

export const FeedPlaylist = () => {
  const { setActivePlaylist } = useMusicState();
  const album = {
    id: '08760502-091b-4f95-9bec-2e0a977492f8',
    upc: '666190400009',
    pk: '',
    albumName: 'The Longevity Code',
    albumArtUrl:
      'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/08760502-091b-4f95-9bec-2e0a977492f8.jpg',
    description: 'The Longevity Code by Lisa Brandt',
    category: 'book',
    genre: [],
    tracks: [
      {
        id: '413c77a6-7723-407f-a206-6a07bb154f6f',
        name: 'Chapter 1: Unlocking Cellular Health: The Science of Longevity',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/413c77a6-7723-407f-a206-6a07bb154f6f/413c77a6-7723-407f-a206-6a07bb154f6f',
        duration: 0,
      },
      {
        id: '80168482-8f7a-4f23-9bcd-9f701ba2fafe',
        name: 'Chapter 2: Intermittent Fasting: Timing Your Way to Health',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/80168482-8f7a-4f23-9bcd-9f701ba2fafe/80168482-8f7a-4f23-9bcd-9f701ba2fafe',
        duration: 0,
      },
      {
        id: '4f1bf86f-30a0-485a-9c19-ee18d0a2d510',
        name: 'Chapter 3: Cold Exposure: Embracing the Chill for Health',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/4f1bf86f-30a0-485a-9c19-ee18d0a2d510/4f1bf86f-30a0-485a-9c19-ee18d0a2d510',
        duration: 0,
      },
      {
        id: '3a04bfc5-8620-4ca6-b456-81e22d0fab19',
        name: 'Chapter 4: Supplementation Strategies: Targeting Nutritional Needs',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/3a04bfc5-8620-4ca6-b456-81e22d0fab19/3a04bfc5-8620-4ca6-b456-81e22d0fab19',
        duration: 0,
      },
      {
        id: '2ccb8de7-3a9f-469d-ba43-8f4b9b4adef4',
        name: 'Chapter 5: The Mind-Body Connection: Psychology of Longevity',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/2ccb8de7-3a9f-469d-ba43-8f4b9b4adef4/2ccb8de7-3a9f-469d-ba43-8f4b9b4adef4',
        duration: 0,
      },
      {
        id: 'f02c4aa5-3c66-4ec5-8571-88b11a064cc8',
        name: 'Chapter 6: Building a Longevity Community: The Power of Connection',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/f02c4aa5-3c66-4ec5-8571-88b11a064cc8/f02c4aa5-3c66-4ec5-8571-88b11a064cc8',
        duration: 0,
      },
      {
        id: 'b54423fd-f9b4-4563-a150-2cfaf43d2ffc',
        name: 'Chapter 7: Integrating Longevity Practices into Daily Life',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/b54423fd-f9b4-4563-a150-2cfaf43d2ffc/b54423fd-f9b4-4563-a150-2cfaf43d2ffc',
        duration: 0,
      },
      {
        id: '21becb7b-5189-44d3-8121-84595ce11cb2',
        name: 'Chapter 8: Navigating Risks and Benefits: A Balanced Perspective',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/21becb7b-5189-44d3-8121-84595ce11cb2/21becb7b-5189-44d3-8121-84595ce11cb2',
        duration: 0,
      },
      {
        id: '93c2630a-b75b-4cc6-b2bb-9f6caf5b2030',
        name: 'Chapter 9: Your Longevity Journey: Embracing the Process',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/93c2630a-b75b-4cc6-b2bb-9f6caf5b2030/93c2630a-b75b-4cc6-b2bb-9f6caf5b2030',
        duration: 0,
      },
      {
        id: '5ea3f20d-141d-48e4-8d64-0683cbfa221c',
        name: 'Chapter 10: A Lifelong Commitment to Longevity',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/tracks/5ea3f20d-141d-48e4-8d64-0683cbfa221c/5ea3f20d-141d-48e4-8d64-0683cbfa221c',
        duration: 0,
      },
    ],
    contributors: [
      {
        id: '91abcddd-1c5f-43b9-ab14-982f30461a1d',
        givenName: 'Lisa Brandt',
        thumbnailUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/91abcddd-1c5f-43b9-ab14-982f30461a1d.jpg',
        videoDesktopUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/91abcddd-1c5f-43b9-ab14-982f30461a1d_desktop.mp4',
        videoMobileUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/91abcddd-1c5f-43b9-ab14-982f30461a1d_mobile.mp4',
      },
    ],
    likes: 1200,
    type: 'Album',
  };
  const playMusic = () => {
    const playlist = {
      currentIndex: 0,
      album: album,
    };
    setActivePlaylist(playlist);
  };
  return (
    <div className="w-full bg-[linear-gradient(180deg,rgba(41,47,255,0.2)_0%,rgba(41,47,255,0)_100%)] rounded-[16px] pb-[16px] font-[NapsterSans]">
      <div className="flex p-4 w-full gap-2 items-center">
        <div className="flex w-[36px] h-[36px]">
          <img
            className="w-full h-full object-cover"
            src="https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/73d9cac0-21a2-4e14-9762-58ccb4e93ee0/73d9cac0-21a2-4e14-9762-58ccb4e93ee0.jpg"
            alt="User"
          />
        </div>
        <div className="flex flex-col flex-1 font-[NapsterSans]">
          <div className="flex text-[14px] font-semibold leading-[130%] text-left text-white pb-[2px]">
            Lisa Brandt
          </div>
          <div className="flex gap-[5px] items-center">
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60 pb-[2px]">
              @lisa.brandt
            </div>
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60">
              • now
            </div>
            <div className="flex">
              {' '}
              <button className="text-[8px] font-normal leading-[130%] text-left text-white/60 border border-white/20 p-[3px] rounded-[4px]">
                playlist
              </button>
            </div>
          </div>
        </div>
        <div className="flex">{/* <OptionsIcon opacityValue={0.8} /> */}</div>
      </div>

      <div className="w-full p-4 pt-[0] text-[14px] font-normal leading-[130%] text-left text-white font-[NapsterSans]">
        <a
          onClick={playMusic}
          href="#"
          className="w-full text-[14px] font-normal leading-[130%] text-left text-[#0FF]">
          The Longevity Code
        </a>{' '}
        The Longevity Code by Lisa Brandt
      </div>

      <div className="flex w-full relative px-4 pb-4">
        <div className="flex w-full h-full shadow-[0_4px_32px_0_rgba(0,0,0,0.4)] relative">
          <img
            className="w-full h-full rounded-[8px]"
            src="https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/08760502-091b-4f95-9bec-2e0a977492f8.jpg"
            alt=""
          />

          <div
            className="w-[40px] h-[40px] absolute left-[12px] bottom-[12px] flex items-center justify-center"
            onClick={playMusic}>
            <PlayIcon width={34} height={34} />
          </div>
          <div className="w-[40px] h-[40px] absolute right-[12px] bottom-[12px] flex items-center justify-center bg-[rgba(0,0,0,0.2)] rounded-full">
            <RightArrowIcon2 width={21} height={20} />
          </div>
        </div>
      </div>

      <div className="w-full text-[12px] font-medium leading-[130%] text-white text-center pb-3">
        The Longevity Code
      </div>

      {/* <div className="flex w-full gap-[4px] relative z-[1] pt-4 px-4">
        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <FavoriteIcon width={16} height={16} fillOpacity={0.8} />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <CommentIcon />

          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <SavedIcon />

          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>
      </div> */}
    </div>
  );
};
